import validate from "/builds/on-that-ass/Frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45ip_45address_45global from "/builds/on-that-ass/Frontend/app/middleware/01.ipAddress.global.ts";
import _01_45token_45login_45global from "/builds/on-that-ass/Frontend/app/middleware/01.tokenLogin.global.ts";
import _02_45i18n_45global from "/builds/on-that-ass/Frontend/app/middleware/02.i18n.global.ts";
import _03_45set_45website_45category_45global from "/builds/on-that-ass/Frontend/app/middleware/03.setWebsiteCategory.global.ts";
import _04_45attribution_45global from "/builds/on-that-ass/Frontend/app/middleware/04.attribution.global.ts";
import _05_45gtm_45global from "/builds/on-that-ass/Frontend/app/middleware/05.gtm.global.ts";
import _06_45retargeting_45global from "/builds/on-that-ass/Frontend/app/middleware/06.retargeting.global.ts";
import _07_45back_45button_45global from "/builds/on-that-ass/Frontend/app/middleware/07.backButton.global.ts";
import manifest_45route_45rule from "/builds/on-that-ass/Frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45ip_45address_45global,
  _01_45token_45login_45global,
  _02_45i18n_45global,
  _03_45set_45website_45category_45global,
  _04_45attribution_45global,
  _05_45gtm_45global,
  _06_45retargeting_45global,
  _07_45back_45button_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/on-that-ass/Frontend/app/middleware/auth.ts"),
  forwarder: () => import("/builds/on-that-ass/Frontend/app/middleware/forwarder.js"),
  "header-check": () => import("/builds/on-that-ass/Frontend/app/middleware/headerCheck.js"),
  homepage: () => import("/builds/on-that-ass/Frontend/app/middleware/homepage.ts"),
  landing: () => import("/builds/on-that-ass/Frontend/app/middleware/landing.ts"),
  "modify-headers": () => import("/builds/on-that-ass/Frontend/app/middleware/modifyHeaders.js"),
  "signup-men": () => import("/builds/on-that-ass/Frontend/app/middleware/signupMen.js"),
  "special-design": () => import("/builds/on-that-ass/Frontend/app/middleware/special-design.ts")
}